module.exports = __webpack_public_path__ + "static/media/hungary.d5f4a663.png";